import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * Closing call to action.
 *
 * Single action by design: the previous "Live Demo" button pointed at
 * /dashboard, which bounces a logged-out visitor to the login screen. There is
 * nothing to demo behind it, so it is gone until there is.
 */
export default function CTA(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, textAlign: "center" }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h5" fontWeight={700}>
          Stop running your calendar out of a spreadsheet.
        </Typography>
        <Typography color="text.secondary" maxWidth={640}>
          Solid Slate replaces the holds spreadsheet, the advancement email
          thread, and the settlement calculator with a single workflow.
        </Typography>
        <Box sx={{ pt: 1 }}>
          <Button
            variant="contained"
            size="large"
            disableElevation
            onClick={() => navigate("/auth/signup")}
            sx={{ px: 4, py: 1.25 }}
          >
            Create your account
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
}
